module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/mobile-500_49b5fa.jpg";